import dynamic from 'next/dynamic';
import Head from 'next/head';
import Script from 'next/script';
import React from 'react';

import type { NextPageWithLayout } from 'nextjs/types';

const TelegramGame = dynamic(
  () => import('ui/telegram-game/telegram-game').then((module) => module.TelegramGame),
  { ssr: false },
);

function announceTelegramReady(): void {
  window.dispatchEvent(new Event('telegram-web-app-ready'));
}

const Page: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>DOTO Bitcoin Flight</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"/>
      </Head>
      <Script
        src="https://telegram.org/js/telegram-web-app.js"
        strategy="afterInteractive"
        onReady={ announceTelegramReady }
      />
      <TelegramGame/>
    </>
  );
};

Page.getLayout = function getLayout(page: React.ReactElement) {
  return page;
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps/main';
